export default "__VITE_ASSET__7936e175__"